import React from "react";
import "../css/MissionInfographic.css";

const data = [
  {
    title: "Mission",
    icon: "🌍",
    color: "teal",
    description:
      "To empower individuals globally with accessible, accurate, and intelligent point-of-care diagnostics and digital health solutions, transforming chronic disease management into a proactive and personalized journey towards sustained well-being.",
  },
  {
    title: "Vision",
    icon: "👁️",
    color: "orange",
    description:
      "To lead the evolution of healthcare by pioneering innovative biosensing technologies and integrated digital platforms, creating a world where individuals are empowered to take control of their health, leading to healthier lives and reduced chronic disease burdens.",
  },
];

const MissionInfographic = () => {
  return (
    <div className="mission-container">
      <div className="mission-grid">
        {data.map((item, index) => (
          <div key={index} className="mission-card">
            <div className={`icon bg-${item.color}`}>{item.icon}</div>
            <h3 className="title">{item.title}</h3>
            <p className="description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MissionInfographic;
